export const MAIN_COLOR = '#0D2259';
export const MAIN_DARK_COLOR = '#172447';
export const SECONDARY_COLOR = '#70CE73';
